import { CommissionCahierEdition } from './commission-cahier-edition.model';
import { CommissionEchantillonEdition } from './commission-echantillon-edition.model';
import { CommissionJureEdition } from './commission-jure-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { CommissionSyntheseEdition } from './commission-synthese-edition.model';
import { CommissionJuryEdition } from './commission-jury-edition.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class CommissionEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        date: { key: 'date', optional: true, default: '' },
        lieu: { key: 'lieu', optional: true, default: '' },
        codepostal: { key: 'codepostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        numero: { key: 'numero', optional: true, default: '' },
        heure: { key: 'heure', optional: true, default: '' },
        nbJures: { key: 'nbJures', optional: true, default: '' },
        nbJuresPresents: { key: 'nbJuresPresents', optional: true, default: '' },
        responsable: { key: 'responsable', optional: true, default: '' },
        idResponsable: { key: 'idResponsable', optional: true },
        synthese: { key: 'synthese', converter: new (ClassConverterFactory.build(CommissionSyntheseEdition))(), optional: true },
        cahiers: { key: 'cahiers', converter: new (ArrayClassConverterFactory.build(CommissionCahierEdition))(), optional: true, default: () => [] },
        echantillons: {
            key: 'echantillons',
            converter: new (ArrayClassConverterFactory.build(CommissionEchantillonEdition))(),
            optional: true,
            default: () => []
        },
        jures: { key: 'jures', converter: new (ArrayClassConverterFactory.build(CommissionJureEdition))(), optional: true, default: () => [] },
        jurys: { key: 'jurys', converter: new (ArrayClassConverterFactory.build(CommissionJuryEdition))(), optional: true, default: () => [] },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true },
        annee: { key: 'annee', optional: true, default: '' },
    };

    id: number;
    date: string;
    lieu: string;
    codepostal: string;
    ville: string;
    adresse: string;
    numero: string;
    heure: string;
    nbJures: string;
    nbJuresPresents: string;
    responsable: string;
    idResponsable: number;
    synthese: CommissionSyntheseEdition;
    cahiers: CommissionCahierEdition[];
    echantillons: CommissionEchantillonEdition[];
    jures: CommissionJureEdition[];
    jurys: CommissionJuryEdition[];
    organisme: OrganismeEdition;
    annee: string;
}
